import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/transaction.model';
import { useTranslation } from 'react-i18next';

interface TokenCardComponentProps {
  transaction: TransactionModel;
}

export const TokenCardComponent = ({
  transaction,
}: TokenCardComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card flex={1}>
      <Stack gap={GapEnum.L} direction="column">
        <Stack
          gap={GapEnum.M}
          justifyContent="space-between"
          alignItems="center">
          <AccentTitle
            icon="credit-card-01"
            as={HeadingEnum.H2}
            text={t('delmonicos-shared-sdk.outputs-transaction.token')}
            variant={AccentVariantEnum.Secondary}
          />
          <Text>{transaction.token?.visualNumber ?? '-'}</Text>
        </Stack>
        <Stack
          gap={GapEnum.M}
          justifyContent="space-between"
          alignItems="center">
          <Text bold>
            <Icon name="building-01" />
            {t('delmonicos-shared-sdk.outputs-token.issuer')}
          </Text>
          <Text>{transaction.token?.issuer ?? '-'}</Text>
        </Stack>
      </Stack>
    </Card>
  );
};
